import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import BottomNav from "@/components/BottomNav";
import InstallPrompt from "@/components/InstallPrompt";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Home from "@/pages/Home";
import Scan from "@/pages/Scan";
import Recipes from "@/pages/Recipes";
import RecipeDetail from "@/pages/RecipeDetail";
import EditRecipe from "@/pages/EditRecipe";
import AddRecipe from "@/pages/AddRecipe";
import Week from "@/pages/Week";
import Shopping from "@/pages/Shopping";
import More from "@/pages/More";
import History from "@/pages/History";
import Trash from "@/pages/Trash";
import Duplicates from "@/pages/Duplicates";
import { ChefHat } from "lucide-react";

function Layout() {
  const location = useLocation();
  return (
    <div className="App min-h-screen" style={{ background: "var(--at-bg)" }}>
      <div className="mx-auto max-w-2xl pb-28">
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </div>
      <BottomNav />
      <InstallPrompt />
    </div>
  );
}

function Splash() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4" style={{ background: "var(--at-brand)" }}>
      <div className="flex h-20 w-20 items-center justify-center rounded-3xl bg-white/15 text-white at-pop backdrop-blur">
        <ChefHat size={40} />
      </div>
      <p className="font-display text-4xl font-bold text-white">À Table</p>
    </div>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user) {
    return (
      <Routes>
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/scan" element={<Scan />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/recipes/:id" element={<RecipeDetail />} />
        <Route path="/recipes/:id/edit" element={<EditRecipe />} />
        <Route path="/add" element={<AddRecipe />} />
        <Route path="/week" element={<Week />} />
        <Route path="/shopping" element={<Shopping />} />
        <Route path="/more" element={<More />} />
        <Route path="/history" element={<History />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/duplicates" element={<Duplicates />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
